<template lang="pug">
	.stations-log
		Dashboard(ref="dashboard", v-if="$auth.isStationOwner()", mode='station', @load-data="() => $forceUpdate()")
			DxButton(slot="filters", :text="$tCaption('Program log')", :icon="!isGeneratingReport ? 'download' : 'more'", @click="downloadProgramLog", :disabled="isGeneratingReport || !stationId() || !logDate()", :title="$tCaption('Download program log')")
</template>

<script>
import Dashboard from './Dashboard.vue';
import DxButton from 'devextreme-vue/button';
import moment from 'moment';

export default {
		translationCategory: 'reconciliation.StationsLog',
	components: {
		Dashboard, DxButton
	},
	data() {
		return {
			isGeneratingReport: false
		}
	},
	mounted() {
		if (__DEBUG__)
			window.stationLogs = this;
	},
	methods: {
		stationId() {
			return this.$refs.dashboard && this.$refs.dashboard.stationId;
		},
		logDate() {
			return this.$refs.dashboard && this.$refs.dashboard.period.from;
		},
		downloadProgramLog() {
			this.isGeneratingReport = true;
			var date = moment(this.logDate()).format('YYYY-MM-DD');
			this.$Data.postMethod(`externalApi?method=Reconciliation/GenerateLogReport&parameters=${encodeURIComponent(`stationId=${this.stationId()}&logDate=${date}&breakOffset=${parseInt(moment().utcOffset() / 60)}`)}`,
			{
				method: 'GET',
				xhr: () => {
					var xhr = new XMLHttpRequest();
					xhr.responseType= 'blob';
					return xhr;
				},
				processData: false,
				dataType: 'binary'
			}).then(data => {
				if (__DEBUG__)
					console.debug('GenerateLogReport response1', { data });
				var objUrl = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
				var link = document.createElement('a');
				link.href = objUrl;
				link.download = `program-log-${date}.pdf`;
				link.click();
			}).finally(() => this.isGeneratingReport = false);
		}
	}
};
</script>
<style lang="scss">
	.stations-log {
		@import "main/themes/generated/variables.base.scss";

	}
</style>
